import { exhaustAll } from './exhaustAll';
export const exhaust = exhaustAll;
